const script = document.createElement("script")
script.type = "text/javascript"
script.src = "https://plug-platform.devrev.ai/static/plug.js"
document.querySelector("head")?.appendChild(script)
